import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    // Allow scrolling
    document.body.style.overflow = 'auto'
    // Scroll to top on route change
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollToTop
